import { create } from 'zustand';
import {
  WORKSPACE_WINDOW_KIND,
  type CurrentWorkspaceInfo,
  type WorkspaceDescriptor,
} from '../electron-shared/workspace/workspace-descriptor';

type WorkspaceStatus = 'unsupported' | 'loading' | 'ready' | 'unscoped';

type WorkspaceState = {
  status: WorkspaceStatus;
  current: CurrentWorkspaceInfo | null;
  setResolved: (current: CurrentWorkspaceInfo) => void;
  setStatus: (status: WorkspaceStatus) => void;
};

const resolveInitialStatus = (): WorkspaceStatus =>
  typeof window !== 'undefined' && window.electronAPI?.workspace
    ? 'loading'
    : 'unsupported';

export const useWorkspaceStore = create<WorkspaceState>()((set) => ({
  status: resolveInitialStatus(),
  current: null,
  setResolved: (current) => set({ current, status: 'ready' }),
  setStatus: (status) => set({ status }),
}));

export const useCurrentWorkspace = (): WorkspaceDescriptor | null =>
  useWorkspaceStore((state) =>
    state.current?.kind === WORKSPACE_WINDOW_KIND.WORKSPACE
      ? state.current.workspace
      : null,
  );

export const useIsWorkspacePicker = (): boolean =>
  useWorkspaceStore(
    (state) => state.current?.kind === WORKSPACE_WINDOW_KIND.PICKER,
  );

export const useIsWorkspaceResolving = (): boolean =>
  useWorkspaceStore((state) => state.status === 'loading');
